<script>
    import { onMount } from 'svelte';
    import { appSettings } from "../stores";
    import { link } from "svelte-routing";
    import { orte, personen } from "../stores";
    import BottomNavOrte from "../components/navigation/BottomNavOrte.svelte";
    
    export let id;
    let ort = orte.filter(i => i.id == id)[0];
    let bewohner = personen.filter(i => i.home && i.home == id);

    function reload (event) {
        console.log(event.detail);
        id = event.detail.id;
        ort = orte.filter(i => i.id == id)[0];
        bewohner = personen.filter(i => i.home && i.home == id);
        $appSettings.currentPageLink = "/orte/"+id;
        $appSettings.currentPageName = ort.street+" "+ort.housenumber;
        $appSettings.parentPage = "/orte";
        window.scrollTo(0, 0);
    }

    onMount ( () => {
        $appSettings.currentPageLink = "/orte/"+id;
        $appSettings.currentPageName = ort.street+" "+ort.housenumber;
        $appSettings.parentPage = "/orte";
        $appSettings.ortIndex = orte.indexOf(ort);
        window.scrollTo(0, 0);
    })
</script>

<div class="img-wrapper">
    <div class="img-container" style="background-image: url('/images/orte/title_preview/{ort.title_img}');"></div>
</div>
<span class="img-src">Bildquelle: {ort.title_img_src}</span>
<br>
{#if ort}
    <h1>{ort.street??"Unbekannte Straße"} {ort.housenumber??""}</h1>
    <!-- <h1>{ort.street??"Unbekannte Straße"} {ort.housenumber??""}{ort.suburb?", "+ort.suburb:""}</h1> -->
    <p>{ort.description??"Für diesen Ort sind keine weiteren Informationen vorhanden…"}</p>
    {#if bewohner.length > 0}
        <br>
        <h2>Bewohner</h2>
        <ul>
            {#each bewohner as person}
                <li>
                    <span class="link-arrow">»</span><a href="/personen/{person.id}" use:link>{person.name}</a>
                </li>
            {/each}  
        </ul>
    {/if}
    {#if ort.extra_img_1}
        <br>
        <img src="/images/orte/extra_original/{ort.extra_img_1}" alt="">
        <span class="img-src">Bildquelle: {ort.extra_img_1_src??"unbekannt"}</span>
        <br>
    {/if}
    {#if ort.extra_img_2}
        <br>
        <img src="/images/orte/extra_original/{ort.extra_img_2}" alt="">
        <span class="img-src">Bildquelle: {ort.extra_img_2_src??"unbekannt"}</span>
        <br>
    {/if}
{/if}
<BottomNavOrte on:reload={reload}/>

<style>
    .img-wrapper {
        position: relative;
        width: 100%;
        padding-top: 60%; /* old position-top-hack, to force aspect ration of 3:2 */
        border-radius: 0.6rem;
        background-color: #101010;
        overflow: hidden;
    }

    .img-container {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }

    .img-src {
        font-size: 0.8rem;
        font-style: italic;
        text-align: center;
        display: block;
        padding: 0.5rem;
        color: #FFFFFFA0;
    }

    img {
        max-width: 100%;
        display: block;
        margin: auto;
        height: auto;
    }

    ul {
        margin: 0;
        padding-inline-start: 0px;
        list-style: none;

    }

    li {
        padding: 0.25rem;
        padding-left: 0;
    }

    a {
        color: #FFFFFFA0;
    }

    .link-arrow {
        padding-right: 0.5rem;
        color: #FFFFFFA0;
    }
</style>